var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInFile)?_c('div',{staticClass:"talk-sidebar-callview"},[(_vm.showCallView)?_c('TopBar',{attrs:{"is-in-call":true,"is-sidebar":true}}):_vm._e(),_vm._v(" "),(_vm.showCallView)?_c('CallView',{attrs:{"token":_vm.token,"is-sidebar":true}}):_vm._e(),_vm._v(" "),_c('PreventUnload',{attrs:{"when":_vm.warnLeaving}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }